import ApiAccess from "@/services/ApiAccess.js";

export const state = {
  albums: []
};

export const mutations = {
  SET_ALBUMS(state, albums) {
    state.albums = albums;
  }
};

export const actions = {
  fetchAlbums({ commit, dispatch }) {
    return ApiAccess.getAllAlbums()
      .then(response => {
        var albums = response.data.data.filter(itm => itm.metadata.album != "");
        var albumTitles = new Array();
        var i;
        for (i = 0; i < albums.length; i++) {
          var albumTitle = albums[i].metadata.album.toString();
          if (albumTitles.indexOf(albumTitle) < 0)
            albumTitles[albumTitles.length] = albumTitle;
        }
        commit("SET_ALBUMS", albumTitles);
        return albumTitles;
      })
      .catch(error => {
        dispatch("setNotification", "Error Fetching Albums: " + error.message, {
          root: true
        });
      });
  }
};
